import { Button } from "@mui/material";
import React from "react";
import { PDFDocument, rgb } from "pdf-lib";
import eleme_sebf_png from "../../../../files/pdfBackgrounds/2026/03_sebf_katilim.png";
import gilroyFont from "../../../../files/fonts/Gilroy-Bold.ttf";

import fontkit from "@pdf-lib/fontkit";

export const KatilimSebfDocument2026 = (props) => {
  const onDownload = async () => {
    const pdfDoc = await PDFDocument.create();
    pdfDoc.registerFontkit(fontkit);
    // 1132x1600 pixels = 850x1200 points (at 96 DPI)
    const page = pdfDoc.addPage([850, 1200]);

    const pngUrl = eleme_sebf_png;
    const pngImageBytes = await fetch(pngUrl).then((res) => res.arrayBuffer());

    const fontBytes = await fetch(gilroyFont).then(
      (res) => res.arrayBuffer() //Fontu da pdf içine gömebilmek için byte array'e dönüştürüyoruz.
    );
    const customFont = await pdfDoc.embedFont(fontBytes);
    const pngImage = await pdfDoc.embedPng(pngImageBytes);

    // Görseli tam sayfa boyutuna sığdır (1132x1600 pixels = 850x1200 points)
    page.drawImage(pngImage, {
      x: 0,
      y: 0,
      width: 850,
      height: 1200,
    });

    // Metin konumları yeni sayfa boyutuna göre ayarlandı (1.43x oranında)
    page.drawText(props.userName, {
      x: 257,
      y: 1065,
      size: 16,
      color: rgb(0, 0, 0),
      font: customFont,
      lineHeight: 31,
    });

    // fileNumber: Firebaseden alınana öncelik ver
    let fileNumberStr = props.fileNumber
      ? props.fileNumber.toString()
      : "BULUNAMADI";
    const fileNumber = "TZV-OYUN26/" + fileNumberStr;
    page.drawText(fileNumber, {
      x: 626,
      y: 800,
      size: 11,
      color: rgb(0, 0, 0),
      font: customFont,
      lineHeight: 31,
    });
    page.drawText(fileNumber, {
      x: 495,
      y: 316,
      size: 12,
      color: rgb(0, 0, 0),
      font: customFont,
      lineHeight: 31,
    });

    const pdfBytes = await pdfDoc.save();

    var blob = new Blob([pdfBytes], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = props.userName + " (SEBF)";
    link.download = fileName;
    link.click();
  };

  return (
    <Button
      title="İlkokul, ortaokul ve lise öğrencileri için MEB sistemine yüklenmek üzere hazırlanmış Sosyal Etkinlik Bilgilendirme Formu."
      variant="contained"
      style={{
        width: 180,
        textTransform: "none",
        alignSelf: "center",
        marginTop: 10,
      }}
      onClick={onDownload}
    >
      2026 SEBF İndir
    </Button>
  );
};
